module.exports = __webpack_public_path__ + "img/github.29445af0.svg";